var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "281.476px",
    height: "178px",
    viewBox: "0 0 281.476 178",
    style: {
      enableBackground: "new 0 0 281.476 178"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 190.935,
    width: 320.839,
    x: 3.968,
    y: -203.935
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8F6FF"
    },
    d: "M281.476,32c0-11.201,0-16.802-2.18-21.08c-1.917-3.763-4.977-6.823-8.74-8.74 C266.277,0,260.677,0,249.476,0L32.514,0C20.673,0,14.752,0,10.342,2.351c-3.876,2.066-6.964,5.351-8.787,9.347 c-2.075,4.547-1.709,10.456-0.979,22.275l7.045,114c0.653,10.572,0.98,15.857,3.246,19.867c1.995,3.53,5.016,6.37,8.663,8.144 C23.672,178,28.968,178,39.559,178h209.917c11.201,0,16.802,0,21.08-2.18c3.763-1.917,6.823-4.977,8.74-8.74 c2.18-4.278,2.18-9.879,2.18-21.08V32z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M281.476,32c0-11.201,0-16.802-2.18-21.08c-1.917-3.763-4.977-6.823-8.74-8.74 C266.277,0,260.677,0,249.476,0L32.514,0C20.673,0,14.752,0,10.342,2.351c-3.876,2.066-6.964,5.351-8.787,9.347 c-2.075,4.547-1.709,10.456-0.979,22.275l7.045,114c0.653,10.572,0.98,15.857,3.246,19.867c1.995,3.53,5.016,6.37,8.663,8.144 C23.672,178,28.968,178,39.559,178h209.917c11.201,0,16.802,0,21.08-2.18c3.763-1.917,6.823-4.977,8.74-8.74 c2.18-4.278,2.18-9.879,2.18-21.08V32z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4C2A04"
    },
    points: "162.087,51.005 154.777,66.669 156.866,68.758 164.176,52.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4C2A04"
    },
    points: "146.423,53.094 150.6,62.492 147.468,63.536 144.335,53.094  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.228,
    y: 150.209,
    style: {
      fill: "#FBDEB9"
    },
    width: 286.125,
    height: 34.46
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M269.571,170.05H37.708c-1.771,0-3.207-1.436-3.207-3.207v-1.941c0-1.771,1.436-3.207,3.207-3.207 h231.863c1.771,0,3.207,1.436,3.207,3.207v1.941C272.778,168.614,271.342,170.05,269.571,170.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8FBB40"
    },
    d: "M276.955,162.74H9.626c-5.191,0-9.398-4.208-9.398-9.398v0c0-5.191,4.208-9.398,9.398-9.398 h267.328c5.191,0,9.398,4.208,9.398,9.398v0C286.353,158.533,282.145,162.74,276.955,162.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8FBB40"
    },
    d: "M297.84,178.404H22.157c-2.884,0-5.221-2.338-5.221-5.221l0,0c0-2.884,2.338-5.221,5.221-5.221 H297.84c2.884,0,5.221,2.338,5.221,5.221l0,0C303.061,176.066,300.723,178.404,297.84,178.404z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#5F963A"
    },
    cx: 151.645,
    cy: 155.431,
    rx: 60.567,
    ry: 5.221
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A93E"
    },
    d: "M2.317,159.198c4.419,0.193,9.398-4.812,8.354-6.9c5.221,7.31,9.398,4.177,11.487,3.133 s2.088-8.354-3.133-12.531c6.266,1.044,7.31-4.177,6.266-7.31s-7.31-3.133-8.354-3.133c2.089-4.177-1.044-8.354-5.221-8.354 s-5.221,5.221-5.221,5.221s-1.044-5.221-6.266-5.221s-8.354,6.266-7.31,9.398s4.177,4.177,4.177,4.177s-11.487,5.221-9.398,9.398 s7.31,3.133,7.31,3.133S-7.082,158.788,2.317,159.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B03D"
    },
    d: "M3.088,155.996c3.612,0.157,7.683-3.934,6.829-5.641c4.268,5.976,7.683,3.415,9.391,2.561 s1.707-6.829-2.561-10.244c5.122,0.854,5.976-3.415,5.122-5.976c-0.854-2.561-5.976-2.561-6.829-2.561 c1.707-3.415-0.854-6.829-4.268-6.829s-4.268,4.268-4.268,4.268s-0.854-4.268-5.122-4.268s-6.829,5.122-5.976,7.683 s3.415,3.415,3.415,3.415s-9.391,4.268-7.683,7.683s5.976,2.561,5.976,2.561S-4.595,155.661,3.088,155.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97BB4C"
    },
    d: "M4.474,150.241c2.163,0.094,4.6-2.355,4.089-3.377c2.556,3.578,4.6,2.045,5.622,1.533 s1.022-4.089-1.533-6.134c3.067,0.511,3.578-2.045,3.067-3.578c-0.511-1.533-3.578-1.533-4.089-1.533 c1.022-2.045-0.511-4.089-2.556-4.089s-2.556,2.556-2.556,2.556s-0.511-2.556-3.067-2.556s-4.089,3.067-3.578,4.6 c0.511,1.533,2.045,2.045,2.045,2.045s-5.622,2.556-4.6,4.6c1.022,2.045,3.578,1.533,3.578,1.533S-0.126,150.04,4.474,150.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADC765"
    },
    d: "M1.444,144.304c1.281,0.502,3.251-0.47,3.154-1.19c0.801,2.678,2.346,2.176,3.066,2.079 c0.72-0.097,1.456-2.249,0.339-4.004c1.739,0.938,2.572-0.494,2.58-1.521c0.008-1.027-1.836-1.658-2.144-1.763 c1.035-1.019,0.534-2.564-0.696-2.985c-1.23-0.421-2.063,1.011-2.063,1.011s0.218-1.642-1.319-2.168 c-1.537-0.526-3.09,1.003-3.098,2.031c-0.008,1.027,0.809,1.65,0.809,1.65s-3.907,0.381-3.713,1.82s1.836,1.658,1.836,1.658 S-1.281,143.237,1.444,144.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C2A04"
    },
    d: "M72.281,106.351c0,0,3.133,3.133,6.266,6.266s5.221,5.221,5.221,5.221s-3.133,8.354-3.133,13.575 s0,20.885-1.044,22.974s-5.221,4.177-5.221,4.177s9.398,2.089,14.62,2.089s8.354,0,8.354,0s-4.177-5.221-5.221-9.398 s-1.044-24.018,2.089-29.239s11.487-10.965,11.487-10.965l-3.133-1.566c0,0-7.31,7.31-9.398,6.266s2.089-13.575,4.177-17.752 s4.177-9.398,4.177-9.398l-2.089-1.044c0,0-8.354,17.752-9.398,16.708S81.68,88.598,81.68,88.598l-3.133,1.044 c0,0,8.354,18.797,6.266,21.929s-10.443-6.266-10.443-6.266L72.281,106.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8FBB40"
    },
    d: "M253.422,183.625H117.743c-2.039,0-3.692-1.653-3.692-3.692v-3.059 c0-2.039,1.653-3.692,3.692-3.692h135.678c2.039,0,3.692,1.653,3.692,3.692v3.059 C257.114,181.972,255.461,183.625,253.422,183.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#603813"
    },
    d: "M74.37,106.351c0,0,3.133,5.221,6.266,6.266s3.79-0.655,3.79-0.655s-2.633,0.246-4.852-1.756 c-0.932-0.841-4.16-3.854-4.16-3.854H74.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C2A04"
    },
    d: "M191.326,99.041c0,0,3.133,3.133,6.266,6.266s5.221,5.221,5.221,5.221s-3.133,8.354-3.133,13.575 s0,20.885-1.044,22.974s-5.221,4.177-5.221,4.177s9.398,2.089,14.62,2.089s8.354,0,8.354,0s-4.177-5.221-5.221-9.398 s-1.044-24.018,2.089-29.239s11.487-10.965,11.487-10.965l-3.133-1.566c0,0-7.31,7.31-9.398,6.266s2.089-13.575,4.177-17.752 s4.177-9.398,4.177-9.398l-2.089-1.044c0,0-8.354,17.752-9.398,16.708s-8.354-15.664-8.354-15.664l-3.133,1.044 c0,0,8.354,18.797,6.266,21.929s-10.443-6.266-10.443-6.266L191.326,99.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#603813"
    },
    d: "M221.609,102.174c0,0-7.31,7.31-9.398,6.266s2.089-13.575,4.177-17.752s4.177-9.398,4.177-9.398 l-2.089-1.044c0,0-8.354,17.752-9.398,16.708s-8.354-15.664-8.354-15.664l-0.139,0.046c2.651,5.113,6.007,12.931,5.36,18.75 c-1.044,9.398-5.221,33.416-2.089,41.77c2.577,6.873,8.314,8.077,10.271,8.289c-1.164-1.818-2.445-4.136-2.961-6.2 c-1.044-4.177-1.044-24.018,2.089-29.239s11.487-10.965,11.487-10.965L221.609,102.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#603813"
    },
    d: "M193.415,99.041c0,0,3.133,5.221,6.266,6.266s3.79-0.655,3.79-0.655s-2.633,0.246-4.852-1.756 c-0.932-0.841-4.16-3.854-4.16-3.854H193.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M81.184,103.766c0,0,3.308-1.001,3.242-3.785c-0.066-2.785-2.111-4.656-4.504-4.177 c-0.609-0.914-1.479-2.437-3.089-2.089c0.044-4.133-2.045-5.047-3.176-5.352c-1.131-0.305-2.872,0.392-2.872,0.392 s-0.235-0.91-1.218-1.392c-1.11-0.544-2.002,0.192-2.002,0.192s-0.325-2.07-3.981-1.807c-0.134,0.855,0.153,1.615,0.153,1.615 s-0.74-0.261-1.262,0.435c-0.522,0.696,0,1.61,0,1.61s-1.653,0.044-2.089,1.653c-0.435,1.61,0,2.176,0,2.176s-1.479,0-1.871,1.088 c-0.392,1.088-0.392,1.088-0.392,1.088s-4.177,0.696-2.959,5.526c1.218,4.83,5.874,2.48,5.874,2.48s-0.174,1.218,0.914,1.958 c1.088,0.74,3.524,0,3.524,0s0.044,1.928,2.132,2.175c1.662,0.197,3.524-1.523,3.524-1.523s0.87,0.755,2.487,0.536 c0.055-0.128,0.08-0.214,0.08-0.214s0.053,0.073,0.15,0.184c0.24-0.045,0.493-0.109,0.763-0.202 c2.263-0.783,2.654-2.332,2.654-2.332s1.262,1.759,3.448,1.718C81.167,104.712,81.184,103.766,81.184,103.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M153.016,11.358c0,0-0.744-4.875-9.674-3.759s-6.139,8.372-6.139,8.372s-1.581-0.558-2.698,0.93 c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535s0,4.651,0,4.651s-3.163,0-4,2.325c-0.837,2.325-0.837,2.325-0.837,2.325 s-8.93,1.488-6.325,11.813c2.605,10.325,12.558,5.302,12.558,5.302s-0.372,2.605,1.953,4.186s7.535,0,7.535,0 s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256s2.605,2.325,7.442,0.651c4.837-1.674,5.674-4.985,5.674-4.985 s3.628,5.078,9.767,3.31s6.232-8.837,6.232-8.837s7.071-2.139,6.931-8.093s-4.512-9.953-9.628-8.93 c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441c-2.419-0.651-6.139,0.837-6.139,0.837 s-0.501-1.946-2.605-2.977C154.923,9.785,153.016,11.358,153.016,11.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M182.131,46.016c0,0,7.071-2.139,6.931-8.093c-0.14-5.953-4.512-9.953-9.628-8.93 c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441c-2.418-0.651-6.139,0.837-6.139,0.837 s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.695-4.425-8.512-3.863c-0.286,1.828,0.326,3.453,0.326,3.453 s-1.581-0.558-2.698,0.93c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535c-0.93,3.442,0,4.651,0,4.651s-3.163,0-4,2.326 c-0.837,2.326-0.837,2.326-0.837,2.326s-8.93,1.488-6.325,11.813c2.604,10.325,12.558,5.302,12.558,5.302 s-0.372,2.605,1.953,4.186c2.326,1.581,7.535,0,7.535,0s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256 s1.86,1.615,5.317,1.146c0.118-0.274,0.171-0.457,0.171-0.457s0.114,0.156,0.321,0.394c0.513-0.097,1.055-0.233,1.632-0.432 c4.837-1.674,5.674-4.985,5.674-4.985s2.698,3.76,7.371,3.672C182.095,48.04,182.131,46.016,182.131,46.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M153.733,45.086c14.352-3.07,11.366-11.162,24.58-8.372c4.475,0.945,7.99,1.081,10.709,0.859 c-0.306-5.752-4.577-9.582-9.588-8.58c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.55-3.441-6.048-3.865 c0.731,7.33-0.126,18.192-3.44,23.301C138.784,38.109,139.381,48.156,153.733,45.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M179.434,28.994c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-0.683-0.335-1.319-0.429-1.89-0.413 c1.343,1.854,0.421,3.575,5.844,6.366c8.467,4.357,9.767,7.694,14.232,13.893c2.978,4.134,9.069,1.176,13.556,6.909 C188.791,31.877,184.484,27.983,179.434,28.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M171.942,56.715c0,0-0.29-1.887-3.764-1.455c-3.474,0.432-2.388,3.239-2.388,3.239 s-0.615-0.216-1.049,0.36c-0.434,0.576,0,1.332,0,1.332s-1.375,0.036-1.737,1.368c-0.362,1.332,0,1.8,0,1.8s-1.23,0-1.556,0.9 c-0.326,0.9-0.326,0.9-0.326,0.9s-3.474,0.576-2.461,4.571s4.886,2.052,4.886,2.052s-0.145,1.008,0.76,1.62s2.931,0,2.931,0 s0.036,1.595,1.773,1.8c1.383,0.163,2.931-1.26,2.931-1.26s1.013,0.9,2.895,0.252s2.208-1.929,2.208-1.929s1.411,1.965,3.8,1.281 s2.425-3.419,2.425-3.419s2.751-0.828,2.696-3.132c-0.055-2.304-1.755-3.851-3.746-3.455c-0.507-0.756-1.23-2.016-2.569-1.728 c0.036-3.419-1.701-4.175-2.642-4.427c-0.941-0.252-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152 C172.684,56.106,171.942,56.715,171.942,56.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M183.269,70.126c0,0,2.751-0.828,2.696-3.131c-0.055-2.304-1.755-3.851-3.746-3.455 c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427c-0.941-0.252-2.388,0.324-2.388,0.324 s-0.195-0.753-1.013-1.152c-0.923-0.45-1.665,0.159-1.665,0.159s-0.271-1.712-3.311-1.495c-0.111,0.707,0.127,1.336,0.127,1.336 s-0.615-0.216-1.05,0.36c-0.434,0.576,0,1.332,0,1.332s-1.375,0.036-1.737,1.368c-0.362,1.332,0,1.8,0,1.8s-1.23,0-1.556,0.9 s-0.326,0.9-0.326,0.9s-3.474,0.576-2.461,4.571c1.013,3.995,4.885,2.052,4.885,2.052s-0.145,1.008,0.76,1.62 c0.905,0.612,2.931,0,2.931,0s0.036,1.595,1.773,1.8c1.383,0.163,2.931-1.26,2.931-1.26s0.724,0.625,2.069,0.444 c0.046-0.106,0.067-0.177,0.067-0.177s0.044,0.06,0.125,0.152c0.2-0.037,0.41-0.09,0.635-0.167 c1.882-0.648,2.208-1.929,2.208-1.929s1.05,1.455,2.868,1.421C183.255,70.909,183.269,70.126,183.269,70.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M172.221,69.766c5.584-1.188,4.422-4.319,9.563-3.239c1.741,0.366,3.108,0.418,4.166,0.333 c-0.119-2.226-1.781-3.708-3.73-3.32c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427 c-0.941-0.252-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152c-0.923-0.45-1.665,0.159-1.665,0.159s-0.214-1.331-2.353-1.496 c0.285,2.837-0.049,7.039-1.338,9.016C166.405,67.066,166.637,70.954,172.221,69.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M182.22,63.539c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427 c-0.941-0.252-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152c-0.266-0.13-0.513-0.166-0.735-0.16 c0.523,0.717,0.164,1.384,2.273,2.463c3.294,1.686,3.8,2.977,5.537,5.376c1.158,1.6,3.528,0.455,5.274,2.673 C185.86,64.655,184.184,63.148,182.22,63.539z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M129.765,48.95c0,0-0.466-3.034-6.052-2.339c-5.586,0.695-3.841,5.209-3.841,5.209 s-0.989-0.347-1.688,0.579c-0.698,0.926,0,2.141,0,2.141s-2.211,0.058-2.793,2.199c-0.582,2.142,0,2.894,0,2.894 s-1.979,0-2.502,1.447c-0.524,1.447-0.524,1.447-0.524,1.447s-5.586,0.926-3.957,7.351c1.629,6.425,7.856,3.299,7.856,3.299 s-0.233,1.621,1.222,2.605c1.455,0.984,4.714,0,4.714,0s0.058,2.565,2.851,2.894c2.223,0.262,4.714-2.026,4.714-2.026 s1.629,1.447,4.655,0.405s3.55-3.102,3.55-3.102s2.269,3.159,6.11,2.06c3.841-1.1,3.899-5.498,3.899-5.498 s4.424-1.331,4.336-5.035c-0.088-3.704-2.823-6.193-6.023-5.556c-0.815-1.215-1.979-3.241-4.132-2.778 c0.058-5.498-2.735-6.714-4.248-7.119s-3.841,0.521-3.841,0.521s-0.314-1.211-1.629-1.852 C130.958,47.972,129.765,48.95,129.765,48.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M147.979,70.515c0,0,4.424-1.331,4.336-5.035c-0.088-3.704-2.823-6.193-6.023-5.556 c-0.815-1.215-1.979-3.241-4.132-2.778c0.058-5.498-2.735-6.714-4.248-7.119c-1.513-0.405-3.841,0.521-3.841,0.521 s-0.314-1.211-1.629-1.852c-1.484-0.724-2.677,0.255-2.677,0.255s-0.435-2.753-5.325-2.404c-0.179,1.138,0.204,2.148,0.204,2.148 s-0.989-0.347-1.688,0.579c-0.698,0.926,0,2.142,0,2.142s-2.211,0.058-2.793,2.199c-0.582,2.142,0,2.894,0,2.894 s-1.978,0-2.502,1.447c-0.524,1.447-0.524,1.447-0.524,1.447s-5.586,0.926-3.957,7.351c1.629,6.425,7.856,3.299,7.856,3.299 s-0.233,1.621,1.222,2.605c1.455,0.984,4.714,0,4.714,0s0.058,2.565,2.851,2.894c2.223,0.262,4.714-2.026,4.714-2.026 s1.164,1.005,3.326,0.713c0.074-0.17,0.107-0.284,0.107-0.284s0.071,0.097,0.201,0.245c0.321-0.06,0.66-0.145,1.021-0.269 c3.026-1.042,3.55-3.102,3.55-3.102s1.688,2.34,4.611,2.285C147.956,71.774,147.979,70.515,147.979,70.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M130.213,69.936c8.979-1.91,7.111-6.945,15.377-5.209c2.799,0.588,4.998,0.673,6.699,0.535 c-0.191-3.579-2.863-5.962-5.998-5.339c-0.815-1.215-1.979-3.241-4.132-2.778c0.058-5.498-2.735-6.714-4.248-7.119 c-1.513-0.405-3.841,0.521-3.841,0.521s-0.314-1.211-1.629-1.852c-1.484-0.724-2.677,0.255-2.677,0.255s-0.344-2.141-3.784-2.405 c0.457,4.561-0.079,11.319-2.152,14.498C120.862,65.595,121.235,71.846,130.213,69.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M146.291,59.923c-0.815-1.215-1.979-3.241-4.132-2.778c0.058-5.498-2.735-6.714-4.248-7.119 c-1.513-0.405-3.841,0.521-3.841,0.521s-0.314-1.211-1.629-1.852c-0.427-0.208-0.825-0.267-1.183-0.257 c0.84,1.154,0.264,2.225,3.656,3.961c5.297,2.711,6.11,4.787,8.903,8.644c1.863,2.572,5.674,0.732,8.481,4.299 C152.145,61.717,149.451,59.295,146.291,59.923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M106.624,92.884c0,0-0.29-1.887-3.764-1.455s-2.388,3.239-2.388,3.239s-0.615-0.216-1.049,0.36 c-0.434,0.576,0,1.332,0,1.332s-1.375,0.036-1.737,1.368c-0.362,1.332,0,1.8,0,1.8s-1.23,0-1.556,0.9 c-0.326,0.9-0.326,0.9-0.326,0.9s-3.474,0.576-2.461,4.571c1.013,3.995,4.886,2.052,4.886,2.052s-0.145,1.008,0.76,1.62 c0.905,0.612,2.931,0,2.931,0s0.036,1.595,1.773,1.8c1.383,0.163,2.931-1.26,2.931-1.26s1.013,0.9,2.895,0.252 c1.882-0.648,2.208-1.929,2.208-1.929s1.411,1.965,3.8,1.281c2.388-0.684,2.425-3.419,2.425-3.419s2.751-0.828,2.696-3.132 c-0.055-2.304-1.755-3.851-3.746-3.455c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427 s-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152C107.365,92.275,106.624,92.884,106.624,92.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M117.951,106.295c0,0,2.751-0.828,2.696-3.131c-0.055-2.304-1.755-3.851-3.746-3.455 c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427c-0.941-0.252-2.388,0.324-2.388,0.324 s-0.195-0.753-1.013-1.152c-0.923-0.45-1.665,0.159-1.665,0.159s-0.271-1.712-3.311-1.495c-0.111,0.707,0.127,1.336,0.127,1.336 s-0.615-0.216-1.05,0.36c-0.434,0.576,0,1.332,0,1.332s-1.375,0.036-1.737,1.368c-0.362,1.332,0,1.8,0,1.8s-1.23,0-1.556,0.9 c-0.326,0.9-0.326,0.9-0.326,0.9s-3.474,0.576-2.461,4.571c1.013,3.995,4.885,2.052,4.885,2.052s-0.145,1.008,0.76,1.62 c0.905,0.612,2.931,0,2.931,0s0.036,1.595,1.773,1.8c1.383,0.163,2.931-1.26,2.931-1.26s0.724,0.625,2.069,0.444 c0.046-0.106,0.067-0.177,0.067-0.177s0.044,0.06,0.125,0.152c0.2-0.037,0.41-0.09,0.635-0.167 c1.882-0.648,2.208-1.929,2.208-1.929s1.05,1.455,2.868,1.421C117.937,107.078,117.951,106.295,117.951,106.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M106.902,105.935c5.584-1.188,4.422-4.319,9.563-3.239c1.741,0.366,3.108,0.418,4.166,0.333 c-0.119-2.226-1.781-3.708-3.73-3.32c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427 c-0.941-0.252-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152c-0.923-0.45-1.665,0.159-1.665,0.159s-0.214-1.331-2.353-1.496 c0.285,2.837-0.049,7.039-1.338,9.016C101.087,103.236,101.319,107.123,106.902,105.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M116.901,99.708c-0.507-0.756-1.23-2.016-2.569-1.728c0.036-3.419-1.701-4.175-2.642-4.427 c-0.941-0.252-2.388,0.324-2.388,0.324s-0.195-0.753-1.013-1.152c-0.266-0.13-0.513-0.166-0.735-0.16 c0.523,0.717,0.164,1.384,2.273,2.463c3.294,1.686,3.8,2.977,5.537,5.376c1.158,1.6,3.528,0.455,5.274,2.673 C120.542,100.824,118.866,99.317,116.901,99.708z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M206.835,39.103c0,0-0.744-4.875-9.674-3.759c-8.93,1.116-6.139,8.372-6.139,8.372 s-1.581-0.558-2.698,0.93c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535c-0.93,3.442,0,4.651,0,4.651s-3.163,0-4,2.325 s-0.837,2.325-0.837,2.325s-8.93,1.488-6.325,11.813s12.558,5.302,12.558,5.302s-0.372,2.605,1.953,4.186s7.535,0,7.535,0 s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256s2.605,2.325,7.442,0.651c4.837-1.674,5.674-4.985,5.674-4.985 s3.628,5.078,9.767,3.31c6.139-1.767,6.232-8.837,6.232-8.837s7.071-2.139,6.931-8.093s-4.512-9.953-9.628-8.93 c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441c-2.419-0.651-6.139,0.837-6.139,0.837 s-0.501-1.946-2.605-2.977C208.742,37.53,206.835,39.103,206.835,39.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M235.95,73.76c0,0,7.071-2.139,6.931-8.093c-0.14-5.953-4.512-9.953-9.628-8.93 c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441c-2.418-0.651-6.139,0.837-6.139,0.837 s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.695-4.425-8.512-3.863c-0.286,1.828,0.326,3.453,0.326,3.453 s-1.581-0.558-2.698,0.93c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535c-0.93,3.442,0,4.651,0,4.651s-3.163,0-4,2.326 s-0.837,2.326-0.837,2.326s-8.93,1.488-6.325,11.813c2.604,10.325,12.558,5.302,12.558,5.302s-0.372,2.605,1.953,4.186 c2.326,1.581,7.535,0,7.535,0s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256s1.86,1.615,5.317,1.146 c0.118-0.274,0.171-0.457,0.171-0.457s0.114,0.156,0.321,0.394c0.513-0.097,1.055-0.233,1.632-0.432 c4.837-1.674,5.674-4.985,5.674-4.985s2.698,3.76,7.371,3.672C235.914,75.784,235.95,73.76,235.95,73.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M207.552,72.83c14.352-3.07,11.366-11.162,24.58-8.372c4.475,0.945,7.99,1.081,10.709,0.859 c-0.306-5.752-4.577-9.582-9.588-8.58c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.55-3.441-6.048-3.865 c0.731,7.33-0.126,18.192-3.44,23.301C192.603,65.854,193.199,75.9,207.552,72.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M233.253,56.738c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-0.683-0.335-1.319-0.429-1.89-0.413 c1.343,1.854,0.421,3.575,5.844,6.366c8.467,4.357,9.767,7.694,14.232,13.893c2.978,4.134,9.069,1.176,13.556,6.909 C242.61,59.621,238.303,55.728,233.253,56.738z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M188.001,78.522c0,0-0.382-2.503-4.966-1.93c-4.584,0.573-3.152,4.298-3.152,4.298 s-0.812-0.287-1.385,0.478s0,1.767,0,1.767s-1.815,0.048-2.292,1.815c-0.478,1.767,0,2.388,0,2.388s-1.624,0-2.053,1.194 c-0.43,1.194-0.43,1.194-0.43,1.194s-4.584,0.764-3.247,6.064c1.337,5.3,6.446,2.722,6.446,2.722s-0.191,1.337,1.003,2.149 c1.194,0.812,3.868,0,3.868,0s0.048,2.116,2.34,2.388c1.824,0.216,3.868-1.671,3.868-1.671s1.337,1.194,3.82,0.334 c2.483-0.86,2.913-2.559,2.913-2.559s1.862,2.607,5.014,1.699c3.152-0.907,3.199-4.536,3.199-4.536s3.63-1.098,3.558-4.154 s-2.316-5.109-4.943-4.584c-0.669-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873s-3.152,0.43-3.152,0.43 s-0.257-0.999-1.337-1.528C188.98,77.715,188.001,78.522,188.001,78.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M202.947,96.314c0,0,3.63-1.098,3.558-4.154c-0.072-3.056-2.316-5.109-4.943-4.584 c-0.669-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873c-1.242-0.334-3.152,0.43-3.152,0.43 s-0.257-0.999-1.337-1.528c-1.218-0.597-2.197,0.211-2.197,0.211s-0.357-2.271-4.369-1.983c-0.147,0.938,0.167,1.773,0.167,1.773 s-0.812-0.287-1.385,0.477c-0.573,0.764,0,1.767,0,1.767s-1.815,0.048-2.292,1.815c-0.477,1.767,0,2.388,0,2.388 s-1.624,0-2.053,1.194c-0.43,1.194-0.43,1.194-0.43,1.194s-4.584,0.764-3.247,6.064c1.337,5.3,6.446,2.722,6.446,2.722 s-0.191,1.337,1.003,2.149c1.194,0.812,3.868,0,3.868,0s0.048,2.116,2.34,2.388c1.824,0.216,3.868-1.671,3.868-1.671 s0.955,0.829,2.729,0.588c0.061-0.141,0.088-0.234,0.088-0.234s0.059,0.08,0.165,0.202c0.264-0.05,0.541-0.119,0.838-0.222 c2.483-0.86,2.913-2.559,2.913-2.559s1.385,1.93,3.784,1.885C202.928,97.353,202.947,96.314,202.947,96.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M188.369,95.836c7.368-1.576,5.835-5.73,12.618-4.298c2.297,0.485,4.102,0.555,5.497,0.441 c-0.157-2.953-2.35-4.919-4.922-4.404c-0.669-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873 c-1.242-0.334-3.152,0.43-3.152,0.43s-0.257-0.999-1.337-1.528c-1.218-0.597-2.197,0.211-2.197,0.211s-0.282-1.766-3.105-1.984 c0.375,3.763-0.065,9.339-1.766,11.961C180.695,92.255,181.001,97.412,188.369,95.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M201.562,87.575c-0.669-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873 c-1.242-0.334-3.152,0.43-3.152,0.43s-0.257-0.999-1.337-1.528c-0.351-0.172-0.677-0.22-0.97-0.212 c0.69,0.952,0.216,1.835,3,3.268c4.347,2.237,5.014,3.95,7.306,7.132c1.529,2.122,4.656,0.604,6.959,3.547 C206.365,89.055,204.154,87.057,201.562,87.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M226.993,83.408c0,0-0.382-2.503-4.966-1.93c-4.584,0.573-3.152,4.298-3.152,4.298 s-0.812-0.287-1.385,0.478s0,1.767,0,1.767s-1.815,0.048-2.292,1.815c-0.478,1.767,0,2.388,0,2.388s-1.624,0-2.053,1.194 c-0.43,1.194-0.43,1.194-0.43,1.194s-4.584,0.764-3.247,6.064c1.337,5.3,6.446,2.722,6.446,2.722s-0.191,1.337,1.003,2.149 s3.868,0,3.868,0s0.048,2.116,2.34,2.388c1.824,0.216,3.868-1.671,3.868-1.671s1.337,1.194,3.82,0.334 c2.483-0.86,2.913-2.559,2.913-2.559s1.862,2.607,5.014,1.699c3.152-0.907,3.199-4.536,3.199-4.536s3.63-1.098,3.558-4.154 s-2.316-5.109-4.943-4.584c-0.669-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873 c-1.242-0.334-3.152,0.43-3.152,0.43s-0.257-0.999-1.337-1.528C227.971,82.6,226.993,83.408,226.993,83.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M241.939,101.199c0,0,3.63-1.098,3.558-4.154c-0.072-3.056-2.316-5.109-4.943-4.584 c-0.668-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873c-1.242-0.334-3.152,0.43-3.152,0.43 s-0.257-0.999-1.337-1.528c-1.218-0.597-2.197,0.211-2.197,0.211s-0.357-2.271-4.369-1.983c-0.147,0.938,0.167,1.773,0.167,1.773 s-0.812-0.287-1.385,0.477c-0.573,0.764,0,1.767,0,1.767s-1.815,0.048-2.292,1.815c-0.477,1.767,0,2.388,0,2.388 s-1.623,0-2.053,1.194s-0.43,1.194-0.43,1.194s-4.584,0.764-3.247,6.064c1.337,5.3,6.446,2.722,6.446,2.722 s-0.191,1.337,1.003,2.149c1.194,0.812,3.868,0,3.868,0s0.048,2.116,2.34,2.388c1.824,0.216,3.868-1.671,3.868-1.671 s0.955,0.829,2.729,0.588c0.061-0.141,0.088-0.234,0.088-0.234s0.059,0.08,0.165,0.202c0.263-0.05,0.541-0.119,0.838-0.222 c2.483-0.86,2.913-2.559,2.913-2.559s1.385,1.93,3.784,1.885C241.92,102.238,241.939,101.199,241.939,101.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M227.361,100.722c7.368-1.576,5.835-5.73,12.618-4.298c2.297,0.485,4.102,0.555,5.497,0.441 c-0.157-2.953-2.35-4.919-4.922-4.404c-0.668-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873 c-1.242-0.334-3.152,0.43-3.152,0.43s-0.257-0.999-1.337-1.528c-1.218-0.597-2.197,0.211-2.197,0.211s-0.282-1.766-3.105-1.984 c0.375,3.763-0.065,9.339-1.766,11.961C219.687,97.14,219.993,102.298,227.361,100.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M240.554,92.461c-0.668-1.003-1.624-2.674-3.39-2.292c0.048-4.536-2.244-5.539-3.486-5.873 c-1.242-0.334-3.152,0.43-3.152,0.43s-0.257-0.999-1.337-1.528c-0.351-0.172-0.677-0.22-0.97-0.212 c0.69,0.952,0.216,1.835,3,3.268c4.347,2.237,5.014,3.95,7.306,7.132c1.529,2.122,4.656,0.604,6.959,3.547 C245.357,93.941,243.146,91.942,240.554,92.461z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E7E8E9"
    },
    points: "191.326,155.431 105.698,155.431 105.698,94.864 148.512,66.669 191.326,94.864  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D2D4"
    },
    points: "148.512,67.191 105.698,95.386 105.698,155.431 107.595,155.431 107.553,99.545  148.512,72.786 189.057,98.375 189.262,155.431 191.326,155.431 191.326,95.386  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.79,
    y: 109.916,
    style: {
      fill: "#BDBEC0"
    },
    width: 26.106,
    height: 46.036
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.727,
    y: 113.904,
    style: {
      fill: "#BDBEC0"
    },
    width: 17.556,
    height: 30.414
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.99,
    y: 113.904,
    style: {
      fill: "#BDBEC0"
    },
    width: 17.556,
    height: 30.414
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.054,
    y: 111.572,
    style: {
      fill: "#4B2904"
    },
    width: 23.577,
    height: 44.381
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.9,
    y: 112.323,
    style: {
      fill: "#603813"
    },
    width: 21.886,
    height: 43.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.339,
    y: 115.252,
    style: {
      fill: "#603813"
    },
    width: 15.446,
    height: 27.977
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.782,
    y: 115.252,
    style: {
      fill: "#603813"
    },
    width: 15.446,
    height: 27.977
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#512E07"
    },
    d: "M140.054,117.21v33.677h17.839V117.21H140.054z M156.666,149.635H141.28v-31.172h15.386V149.635z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.905,
    y: 117.994,
    style: {
      fill: "#4B2904"
    },
    width: 12.096,
    height: 9.137
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.905,
    y: 129.241,
    style: {
      fill: "#4B2904"
    },
    width: 11.747,
    height: 10.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.457,
    y: 117.994,
    style: {
      fill: "#4B2904"
    },
    width: 12.096,
    height: 9.137
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.457,
    y: 129.11,
    style: {
      fill: "#4B2904"
    },
    width: 12.096,
    height: 10.995
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8FBB40"
    },
    d: "M205.538,170.05H81.043c-1.955,0-3.541-1.585-3.541-3.541v-3.361c0-1.955,1.585-3.541,3.541-3.541 h124.494c1.955,0,3.541,1.585,3.541,3.541v3.361C209.078,168.465,207.493,170.05,205.538,170.05z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 128.671,
    cy: 179.448,
    r: 4.177
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 144.335,
    cy: 178.404,
    r: 2.089
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 168.353,
    cy: 170.05,
    r: 2.089
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 178.795,
    cy: 167.962,
    r: 3.133
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 196.547,
    cy: 170.05,
    r: 6.266
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ADD25A"
    },
    cx: 187.149,
    cy: 162.74,
    r: 3.133
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B4E2A"
    },
    points: "268.601,93.82 268.601,146.032 274.866,146.032 274.866,111.572 286.353,91.731  282.176,87.554 274.866,103.218 272.778,90.687  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59A93E"
    },
    d: "M255.025,61.448c0,0-4.177-4.177-12.531,1.044s-3.133,15.664,2.089,18.797 c-6.266,5.221-3.133,13.575,1.044,15.664s12.531-2.089,12.531-2.089s5.221,7.31,14.62,6.266s10.443-8.354,10.443-8.354 s0,7.31,10.443,7.31s14.62-13.236,14.62-19.841c0-7.31-4.177-10.443-7.31-12.531c5.221-5.221-1.044-15.664-10.443-19.841 s-15.664,2.089-15.664,7.31c-6.266-10.443-12.531-8.354-16.708-6.266C251.893,52.05,255.025,61.448,255.025,61.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B03D"
    },
    d: "M256.648,62.557c0,0-3.804-3.804-11.412,0.951c-7.608,4.755-2.853,14.265,1.902,17.118 c-5.706,4.755-2.853,12.363,0.951,14.265c3.804,1.902,11.412-1.902,11.412-1.902s4.755,6.657,13.314,5.706 c8.559-0.951,9.51-7.608,9.51-7.608s0,6.657,9.51,6.657s13.314-12.055,13.314-18.069c0-6.657-3.804-9.51-6.657-11.412 c4.755-4.755-0.951-14.265-9.51-18.069c-8.559-3.804-14.265,1.902-14.265,6.657c-5.706-9.51-11.412-7.608-15.216-5.706 C253.794,53.998,256.648,62.557,256.648,62.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97BB4C"
    },
    d: "M258.307,63.361c0,0-3.182-3.183-9.548,0.796c-6.365,3.978-2.387,11.934,1.591,14.321 c-4.774,3.978-2.387,10.343,0.796,11.934c3.183,1.591,9.548-1.591,9.548-1.591s3.978,5.569,11.139,4.774 c7.161-0.796,7.956-6.365,7.956-6.365s0,5.569,7.956,5.569c7.956,0,11.139-10.085,11.139-15.117c0-5.569-3.183-7.956-5.569-9.548 c3.978-3.978-0.796-11.934-7.956-15.117c-7.161-3.183-11.934,1.591-11.934,5.569c-4.774-7.956-9.548-6.365-12.73-4.774 C255.92,56.201,258.307,63.361,258.307,63.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADC765"
    },
    d: "M260.457,62.769c0,0-1.639-2.199-5.827-0.36c-4.188,1.839-2.488,6.987-0.299,8.776 c-3.228,1.979-2.349,6.027-0.569,7.267c1.779,1.239,5.897-0.12,5.897-0.12s1.909,3.708,6.297,3.858s5.357-3.139,5.357-3.139 s-0.49,3.358,4.308,4.058s7.603-5.102,8.046-8.137c0.49-3.358-1.22-5.078-2.519-6.247c2.749-2.049,0.569-7.267-3.469-9.815 c-4.038-2.549-7.336-0.09-7.686,2.309c-2.179-5.217-5.198-4.677-7.257-3.998C259.648,58.241,260.457,62.769,260.457,62.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#603813"
    },
    d: "M102.565,109.484c0,0-7.31,7.31-9.398,6.266s2.089-13.575,4.177-17.752s5.998-11.883,5.998-11.883 l-3.91,1.44c0,0-8.354,17.752-9.398,16.708c-0.641-0.641-6.029-11.067-6.029-11.067l-0.231,0.089c0,0,3.591,9.936,3.127,14.11 c-1.044,9.398-5.221,33.416-2.089,41.77c2.577,6.873,8.314,8.077,10.271,8.289c-1.164-1.818-2.445-4.136-2.961-6.2 c-1.044-4.177-1.044-24.018,2.089-29.239s11.487-10.965,11.487-10.965L102.565,109.484z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F47521"
    },
    cx: 149.024,
    cy: 104.505,
    r: 3.394
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.073,
    y: 118.603,
    style: {
      fill: "#55BAD7"
    },
    width: 10.769,
    height: 7.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.678,
    y: 118.603,
    style: {
      fill: "#55BAD7"
    },
    width: 10.769,
    height: 7.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.121,
    y: 129.763,
    style: {
      fill: "#55BAD7"
    },
    width: 10.769,
    height: 9.826
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.324,
    y: 129.763,
    style: {
      fill: "#55BAD7"
    },
    width: 10.769,
    height: 9.826
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81C8E1"
    },
    points: "127.283,118.603 116.515,118.603 116.515,126.304 123.875,126.304 127.283,120.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81C8E1"
    },
    points: "116.324,129.763 116.324,139.589 121.768,129.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81C8E1"
    },
    points: "182.842,118.603 172.073,118.603 172.073,126.304 179.434,126.304 182.842,120.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81C8E1"
    },
    points: "172.026,129.763 172.026,139.589 177.47,129.763  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M88.273,45.968c0,0-0.744-4.875-9.674-3.759c-8.93,1.116-6.139,8.372-6.139,8.372 s-1.581-0.558-2.698,0.93c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535c-0.93,3.442,0,4.651,0,4.651s-3.163,0-4,2.325 c-0.837,2.325-0.837,2.325-0.837,2.325s-8.93,1.488-6.325,11.813c2.605,10.325,12.558,5.302,12.558,5.302 s-0.372,2.605,1.953,4.186s7.535,0,7.535,0s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256 s2.605,2.325,7.442,0.651c4.837-1.674,5.674-4.985,5.674-4.985s3.628,5.078,9.767,3.31c6.139-1.767,6.232-8.837,6.232-8.837 s7.071-2.139,6.931-8.093c-0.14-5.953-4.512-9.953-9.628-8.93c-1.302-1.953-3.163-5.209-6.604-4.465 c0.093-8.837-4.372-10.79-6.79-11.441c-2.419-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.605-2.977 C90.18,44.395,88.273,45.968,88.273,45.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M117.388,80.626c0,0,7.071-2.139,6.931-8.093c-0.14-5.953-4.512-9.953-9.628-8.93 c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441c-2.418-0.651-6.139,0.837-6.139,0.837 s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.695-4.425-8.512-3.863c-0.286,1.828,0.326,3.453,0.326,3.453 s-1.581-0.558-2.698,0.93c-1.116,1.488,0,3.442,0,3.442s-3.535,0.093-4.465,3.535c-0.93,3.442,0,4.651,0,4.651s-3.163,0-4,2.326 c-0.837,2.326-0.837,2.326-0.837,2.326s-8.93,1.488-6.325,11.813c2.604,10.325,12.558,5.302,12.558,5.302 s-0.372,2.605,1.953,4.186c2.326,1.581,7.535,0,7.535,0s0.093,4.122,4.558,4.651c3.554,0.421,7.535-3.256,7.535-3.256 s1.86,1.615,5.317,1.146c0.118-0.274,0.171-0.457,0.171-0.457s0.114,0.156,0.321,0.394c0.513-0.097,1.055-0.233,1.632-0.432 c4.837-1.674,5.674-4.985,5.674-4.985s2.698,3.76,7.371,3.672C117.352,82.65,117.388,80.626,117.388,80.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M88.99,79.696c14.352-3.07,11.366-11.162,24.58-8.372c4.475,0.945,7.99,1.081,10.709,0.859 c-0.306-5.752-4.577-9.582-9.588-8.58c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-2.372-1.163-4.279,0.41-4.279,0.41s-0.55-3.441-6.048-3.865 c0.731,7.33-0.126,18.192-3.44,23.301C74.041,72.719,74.637,82.765,88.99,79.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M114.69,63.603c-1.302-1.953-3.163-5.209-6.604-4.465c0.093-8.837-4.372-10.79-6.79-11.441 c-2.418-0.651-6.139,0.837-6.139,0.837s-0.501-1.946-2.604-2.977c-0.683-0.335-1.319-0.429-1.89-0.413 c1.343,1.854,0.421,3.575,5.844,6.366c8.467,4.357,9.767,7.694,14.232,13.893c2.978,4.134,9.069,1.176,13.556,6.909 C124.048,66.487,119.74,62.593,114.69,63.603z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CB4C23"
    },
    points: "130.213,77.442 115.905,85.073 115.905,64.236 130.213,64.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8431D"
    },
    points: "130.308,75.214 124.337,79.356 124.337,64.236 130.23,64.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1592A"
    },
    points: "200.585,102.343 200.585,98.155 148.512,62.602 96.281,98.263 96.287,103.064  148.512,67.191  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A772E"
    },
    d: "M67.565,87.554c0,0-0.348-2.28-4.525-1.758c-4.177,0.522-2.872,3.916-2.872,3.916 s-0.74-0.261-1.262,0.435c-0.522,0.696,0,1.61,0,1.61s-1.653,0.044-2.088,1.653c-0.435,1.61,0,2.176,0,2.176 s-1.479,0-1.871,1.088c-0.392,1.088-0.392,1.088-0.392,1.088s-4.177,0.696-2.959,5.526s5.874,2.48,5.874,2.48 s-0.174,1.218,0.914,1.958c1.088,0.74,3.524,0,3.524,0s0.044,1.928,2.132,2.176c1.662,0.197,3.524-1.523,3.524-1.523 s1.218,1.088,3.481,0.305c2.263-0.783,2.654-2.332,2.654-2.332s1.697,2.375,4.569,1.548c2.872-0.827,2.915-4.133,2.915-4.133 s3.308-1.001,3.242-3.785c-0.066-2.785-2.111-4.656-4.504-4.177c-0.609-0.914-1.479-2.437-3.089-2.089 c0.044-4.133-2.045-5.047-3.176-5.352c-1.131-0.305-2.872,0.392-2.872,0.392s-0.235-0.91-1.218-1.392 C68.457,86.818,67.565,87.554,67.565,87.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A8634"
    },
    d: "M81.184,103.766c0,0,3.308-1.001,3.242-3.785c-0.066-2.785-2.111-4.656-4.504-4.177 c-0.609-0.914-1.479-2.437-3.089-2.089c0.044-4.133-2.045-5.047-3.176-5.352c-1.131-0.305-2.872,0.392-2.872,0.392 s-0.235-0.91-1.218-1.392c-1.11-0.544-2.002,0.192-2.002,0.192s-0.325-2.07-3.981-1.807c-0.134,0.855,0.153,1.615,0.153,1.615 s-0.74-0.261-1.262,0.435c-0.522,0.696,0,1.61,0,1.61s-1.653,0.044-2.089,1.653c-0.435,1.61,0,2.176,0,2.176 s-1.479,0-1.871,1.088c-0.392,1.088-0.392,1.088-0.392,1.088s-4.177,0.696-2.959,5.526c1.218,4.83,5.874,2.48,5.874,2.48 s-0.174,1.218,0.914,1.958c1.088,0.74,3.524,0,3.524,0s0.044,1.928,2.132,2.175c1.662,0.197,3.524-1.523,3.524-1.523 s0.87,0.755,2.487,0.536c0.055-0.128,0.08-0.214,0.08-0.214s0.053,0.073,0.15,0.184c0.24-0.045,0.493-0.109,0.763-0.202 c2.263-0.783,2.654-2.332,2.654-2.332s1.262,1.759,3.448,1.718C81.167,104.712,81.184,103.766,81.184,103.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9539"
    },
    d: "M67.901,103.331c6.713-1.436,5.317-5.221,11.497-3.916c2.093,0.442,3.737,0.506,5.009,0.402 c-0.143-2.69-2.141-4.482-4.485-4.013c-0.609-0.914-1.479-2.437-3.089-2.089c0.044-4.133-2.045-5.047-3.176-5.352 c-1.131-0.305-2.872,0.392-2.872,0.392s-0.235-0.91-1.218-1.392c-1.11-0.544-2.002,0.192-2.002,0.192s-0.257-1.609-2.829-1.808 c0.342,3.429-0.059,8.509-1.609,10.899C60.908,100.067,61.187,104.766,67.901,103.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BA437"
    },
    d: "M79.922,95.803c-0.609-0.914-1.479-2.437-3.089-2.089c0.044-4.133-2.045-5.047-3.176-5.352 c-1.131-0.305-2.872,0.392-2.872,0.392s-0.235-0.91-1.218-1.392c-0.32-0.157-0.617-0.201-0.884-0.193 c0.628,0.867,0.197,1.672,2.733,2.978c3.961,2.038,4.569,3.599,6.657,6.499c1.393,1.934,4.242,0.55,6.341,3.232 C84.299,97.152,82.284,95.331,79.922,95.803z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M265.662,147.04c1.932-0.234,0.87-4.399-0.261-8.141c-1.131-3.742-5.047-9.005-6.962-8.047 s0.467,1.878,2.611,4.699c1.653,2.176,2.988,5.742,3.046,7.745C264.182,146.341,265.02,147.117,265.662,147.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M265.662,145.471c1.014,0.3,1.479-3.916,1.479-8.354c0-4.438-1.74-10.704-3.307-10.965 c-1.566-0.261-0.435,2.034,0,4.585c0.435,2.551,1.459,6.815,1.252,9.861C264.879,143.643,264.635,145.167,265.662,145.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M268.621,147.045c1.87,0.718,2.089-2.444,1.305-6.882c-0.783-4.438-1.566-8.006-1.305-9.92 c0.261-1.914,2.061-2.912,0.857-4.11s-2.319,3.151-2.336,7.765C267.124,138.511,267.054,146.443,268.621,147.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M271.579,147.147c1.088,0.112,1.653-0.545,1.305-3.938c-0.348-3.394-0.348-10.647-2.089-10.98 s-0.522,5.758,0,8.456C271.318,143.382,270.1,146.995,271.579,147.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M274.451,147.158c1.441,0.153,0.522-3.422,0-7.471c-0.522-4.049,0.348-8.139,1.566-10.402 c1.218-2.263,2.611-4.525,1.827-5.134c-0.783-0.609-2.9,1.837-4.264,6.586S271.492,146.844,274.451,147.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M275.93,146.428c1.654,0.075,0.87-5.943,1.74-9.889s9.311-12.04,8.876-13.432 c-0.435-1.392-1.131-1.044-3.133,0c-2.001,1.044-6.963,6.521-8.181,12.702C274.016,141.99,274.016,146.341,275.93,146.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F963A"
    },
    d: "M278.072,147.163c1.518-0.028,0.382-2.214,0.991-5.173c0.609-2.959,5.221-6.052,4.003-7.682 c-1.218-1.63-5.656,1.431-6.44,6.427C275.843,145.732,275.95,147.201,278.072,147.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB912"
    },
    d: "M146.081,103.994c0,0-0.044,1.523,1.175,2.306s2.045,0.696,2.35,0.348 c0.305-0.348-0.994-0.588-1.561-1.525c-0.699-1.154-0.341-1.35,0.044-1.305L146.081,103.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939598"
    },
    d: "M153.696,104.505c0.416,0,0.716-0.41,0.587-0.806c-0.725-2.218-2.798-3.822-5.259-3.822 c-2.5,0-4.6,1.657-5.293,3.93c-0.105,0.346,0.147,0.699,0.509,0.699H153.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818285"
    },
    d: "M150.721,100.764c0.582,0,1.136,0.107,1.662,0.274c-0.932-0.719-2.088-1.161-3.359-1.161 c-2.512,0-4.62,1.672-5.302,3.962c-0.098,0.33,0.14,0.666,0.485,0.666h1.289C146.245,102.331,148.292,100.764,150.721,100.764z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B8431D"
    },
    points: "96.284,100.501 96.287,103.064 148.512,67.191 200.585,102.343 200.585,100.394  148.512,64.842  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.425,
    y: 134.348,
    style: {
      fill: "#F47521"
    },
    width: 1.697,
    height: 4.177
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7941D"
    },
    cx: 157.29,
    cy: 134.136,
    r: 1.942
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB912"
    },
    d: "M157.29,132.7c-0.146-0.573-1.495,0.193-1.656,0.988c-0.163,0.806,0.048,1.319,0.355,1.368 c0.307,0.049,0.047-0.562,0.332-1.266C156.666,132.934,157.363,132.986,157.29,132.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParent);
export default __webpack_public_path__ + "static/media/parent.e9b9950c86630d143b6c422f696fda57.svg";
export { ForwardRef as ReactComponent };